// extracted by mini-css-extract-plugin
export default {"centered":"Profile_centered__MBkCN","full":"Profile_full__5dFPi","pic":"Profile_pic__rOfCo"};